import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { ListDTO } from 'src/registry/types/queries';
import { formatResourcePath } from 'src/utils/regex';
import { ListResponseAPI } from 'src/lib/queries';
import { Payment, PAYMENT_STATUS } from 'src/features/payments/utils/types';
import { CURRENCY } from 'src/types';

const RESOURCE = '/payments/payment/';

type QueryFnType = typeof queryFn;

interface DTO extends ListDTO {
    item_id?: string;
    item_type?: string;
    status?: PAYMENT_STATUS;
    currency?: CURRENCY;
    allocatable?: boolean;
    customer?: string;
}

const queryFn = ({ ...params }: DTO): Promise<ListResponseAPI<Payment>> => {
    return axios.get(formatResourcePath(RESOURCE), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { RESOURCE as LIST_PAYMENTS_RESOURCE, useQueryHook as useListPayments };
